// extracted by mini-css-extract-plugin
export default {"cardClass":"ForgotPassword_cardClass__5j8tw","control":"ForgotPassword_control__0NZsC","btn":"ForgotPassword_btn__u69fl","action":"ForgotPassword_action__-QIlE"};